// The thumbs up / down glyph for HR's verdict on a call (Resolved Decisions
// #29). Inlined rather than adding an icon package, the same call NotesIcon and
// CapstonMark made — two shapes, one of which is the other rotated.
//
// `filled` is the set state: a solid thumb reads as a decision at 18px where a
// hairline outline reads as a control. Both use currentColor, so the parent's
// `color` carries the verdict's meaning.
export default function ThumbIcon({ direction = 'up', size = 18, filled = false }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      style={{
        display: 'block',
        // Thumbs-down is the same hand upside down — no second path to keep in
        // step with the first.
        transform: direction === 'down' ? 'rotate(180deg)' : undefined,
      }}
    >
      <rect x="3" y="10" width="4" height="10.5" rx="1" />
      <path d="M7 10.5 10.9 3.6c.35-.7 1.3-.85 1.85-.3.4.4.55 1 .4 1.55L12.9 9h4.9a2 2 0 0 1 1.98 2.3l-1.1 7.2a2 2 0 0 1-1.98 2H7z" />
    </svg>
  )
}
